import { render, staticRenderFns } from "./OwnersForm.vue?vue&type=template&id=0aee2846&"
import script from "./OwnersForm.vue?vue&type=script&lang=js&"
export * from "./OwnersForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnersForm.vue?vue&type=style&index=0&id=0aee2846&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports